import { isDefined, toError } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logError } from "@src/appV2/lib/analytics/log";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";

import { useSendCheckrInvitation } from "./useSendCheckrInvitation";

export function useOpenCheckrInvitation() {
  const { mutateAsync: sendCheckrInvitation } = useSendCheckrInvitation();

  return async () => {
    try {
      const { data: updatedCheckrApplicationStatus } = await sendCheckrInvitation();
      const { invitationUrl } = updatedCheckrApplicationStatus;

      if (isDefined(invitationUrl)) {
        await openInBrowser({ url: invitationUrl });
      } else {
        logError(APP_V2_APP_EVENTS.RESEND_CHECKR_INVITATION_FAILURE, {
          error: new Error("No invitation url included in the response"),
          metadata: {
            updatedCheckrApplicationStatus,
          },
        });
      }
    } catch (maybeError: unknown) {
      logError(APP_V2_APP_EVENTS.RESEND_CHECKR_INVITATION_FAILURE, {
        error: toError(maybeError),
      });

      throw toError(maybeError);
    }
  };
}
